export default __webpack_public_path__ + "src/_images/AccelAndRevControl_Icon.svg";